import termImg from "$/service.svg";


const TermsOfServiceContent = () => {
  return (
    <>
    <img src={termImg} alt="terms-of-service" className="w-full h-full" />
    </>
  );
};

export default TermsOfServiceContent; 